import auth from '@middlewares/auth';
import Design from '@views/Design.vue'
import DesignIframe from '@views/DesignIframe.vue'
import RandomRoute from '@views/RandomRoute.vue'
import DesignPreview from '@views/DesignPreview.vue'
import DesignAuthen from '@views/DesignAuthen'
import DesignLogout from '@views/DesignLogout'
import Component from '@views/Component'
import DemoTextEditor from '@views/DemoTextEditor'

export default [
  // Parent
  {
    path: "/init",
    meta: {
      layout: "blank",
    },
    component: DesignAuthen,
  },
  {
    path: "/logout",
    name: 'logout',
    meta: {
      layout: "blank",
    },
    component: DesignLogout,
  },
  {
    path: "/",
    meta: {
      middleware: [auth],
    },
    component: Design,
  },
  {
    path: "/design",
    name: 'design',
    meta: {
      middleware: [auth],
    },
    component: Design,
  },
  {
    path: "/preview",
    name: 'preview',
    meta: {
      middleware: [auth],
      layout: "design-preview",
    },
    component: DesignPreview,
  },
  {
    path: "/component",
    name: 'component',
    meta: {
      layout: "component",
    },
    component: Component,
  },
  {
    path: "/demo-texteditor",
    name: 'demo-texteditor',
    meta: {
      layout: "demo-texteditor",
    },
    component: DemoTextEditor,
  },

  // Child
  {
    path: "/design-iframe",
    meta: {
      layout: "design-iframe",
    },
    component: DesignIframe,
  },
  {
    path: '/instagram-callback',
    beforeEnter: (to, from, next) => {
      const code = to.query.code;
      if (code) {
        localStorage.setItem('AuthorizationCodeInstagram', JSON.stringify({
          code: code, 
          messageType: 'AuthorizationCodeInstagram'
        }));
        window.close();
      }
      next();
    }
  },
  // Random
  {
    path: "/:text",
    meta: {
      middleware: [auth],
    },
    component: RandomRoute,
  },
]